/**
 * KanbanColumn - Coluna do Kanban Board com drag & drop
 */
import { useState } from 'react'
import KanbanCard from './KanbanCard'

export default function KanbanColumn({ status, title, icon, cards, loading, onEditCard, onDeleteCard, onDrop, headerClass, canManageBoard = true, canViewProcessDocuments = false, onViewDocuments }) {
  const [dragOver, setDragOver] = useState(false)

  const handleDragOver = (e) => {
    if (!canManageBoard) return
    e.preventDefault()
    setDragOver(true)
  }

  const handleDragLeave = () => setDragOver(false)

  const handleDrop = (e) => {
    if (!canManageBoard) return
    e.preventDefault()
    setDragOver(false)
    const prazoId = e.dataTransfer.getData('prazoId')
    if (prazoId && onDrop) onDrop(prazoId, status)
  }

  return (
    <section className="kanban-column" data-status={status} aria-labelledby={`kanban-column-${status}`}>
      <div className={`kanban-column-header ${headerClass || status}`}>
        <div className="column-title">
          <i className={`fas ${icon}`} />
          <span id={`kanban-column-${status}`}>{title}</span>
        </div>
        <span className="col-count">{loading ? '...' : cards.length}</span>
      </div>

      <div
        className={`kanban-column-body ${dragOver ? 'drag-over' : ''}`}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
      >
        {loading && cards.length === 0 ? (
          <div className="column-loading">
            <div className="spinner" />
            <p>Carregando prazos...</p>
          </div>
        ) : cards.length === 0 ? (
          <div className="column-empty">
            <i className="fas fa-inbox" />
            <p>Nenhum prazo nesta categoria</p>
          </div>
        ) : (
          <>
            {loading && (
              <div className="column-loading-inline">
                <div className="spinner" />
                <span>Atualizando...</span>
              </div>
            )}
            {cards.map((prazo) => (
              <KanbanCard
                key={prazo.id}
                prazo={prazo}
                onEdit={onEditCard}
                onDelete={onDeleteCard}
                canManageBoard={canManageBoard}
                canViewProcessDocuments={canViewProcessDocuments}
                onViewDocuments={onViewDocuments}
              />
            ))}
          </>
        )}
      </div>
    </section>
  )
}
